import UserLink from 'src/modules/shared/links/userLink';
import Badges from 'src/components/badges/badges';
import i18n from 'src/utils/translate';

export default function LastEditedBy({ editAuthor }) {

  return (
    <div className="last-edited-by">
      <span className="icon-pencil">
        {i18n.t('Last edited by')}{' '}
        <UserLink
          avatar={false}
          user={editAuthor}
        />
      </span>
      {' '}{editAuthor.roles && editAuthor.roles.length > 0 && (
        <Badges roles={editAuthor.roles}/>
      )}
    </div>
  );
}
